<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive" style="padding-bottom: 60px">
              <div class="col-sm-12">
                <div class="pull-right">
                  <el-button type="primary" @click="handleArchiveEvent"
                    >Unarchive</el-button
                  >
                </div>
              </div>
              <div class="col-xs-12">
                {{ total }}{{ $t("message.datagridresult") }}
              </div>
              <el-table
                :data="rows"
                border
                style="width: 100%"
                ref="multipleTable"
                @selection-change="handleSelectionChangeRows1"
                :fit="true"
                row-key="eventCode"
                class="rowss"
                :cell-class-name="cell"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column
                  label="Event Name"
                  :show-overflow-tooltip="true"
                  min-width="200"
                >
                  <template slot-scope="scope">
                    <div>
                      <el-tag
                        type="warning"
                        effect="dark"
                        size="mini"
                        v-if="scope.row.expired"
                      >
                        Expired
                      </el-tag>
                      {{ scope.row.title }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="categoryIds"
                  :show-overflow-tooltip="true"
                  label="Event Category"
                  min-width="130"
                ></el-table-column>
                <el-table-column
                  prop="districtName"
                  :show-overflow-tooltip="true"
                  label="Event Direct"
                  min-width="130"
                ></el-table-column>
                <el-table-column
                  prop="updatedAt"
                  label="Last Update Time"
                  width="170"
                >
                </el-table-column>
                <el-table-column
                  prop="statusName"
                  label="Status"
                  min-width="150"
                ></el-table-column>
                <el-table-column label="Action" width="120" fixed="right">
                  <template slot-scope="scope">
                    <el-row>
                      <el-col :span="12" style="float: right" v-if="canDrag">
                        <div class="text-center dragTip">=</div>
                      </el-col>

                      <el-col :span="12" style="float: right">
                        <el-button
                          size="mini"
                          @click="handleDbClick(scope.row)"
                          icon="el-icon-edit"
                        ></el-button>
                      </el-col>
                    </el-row>
                  </template>
                </el-table-column>
              </el-table>
              <el-col :span="24" class="el-table_footertoolbar">
                <el-pagination
                  layout="total, sizes, prev, pager, next, jumper"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :page-sizes="[10, 20, 50, 100, 200]"
                  :page-size="pagesize"
                  :total="total"
                  style="float: right"
                >
                </el-pagination>
              </el-col>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="selectCaptchaDlg"
      width="70%"
      :append-to-body="true"
      center
    >
      <div class="form-group">
        <img :src="captcha.captchaImage" />
      </div>
      <div class="form-group">
        <el-input v-model="answer"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="form-group">
          <el-button @click="selectCaptchaDlg = false">Cancel</el-button>
          <el-button type="primary" @click="syncEvent()">Confirm</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import config from "../config";
import Sortable from "sortablejs";
import StatusBtn from "../components/common/statusBtn.vue";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      eventListSelected:[],
      page: 1, //当前页数
      pagesize: 10, //一页显示几条
      filter: "",
      name: "",
      searchStatus: null,
      total: 0,
      rows: [],
      multipleSelection: [],
      sortType: "ASC",
      sortField: "sortOrder",
      status: "",
      statusObj: [],
      typeObj: [],
      type: "",
      status: "",
      startDate: "",
      endDate: "",
      period: null,
      canDrag: false,
      searchName: "",
      captcha: {},
      answer: "",
      selectCaptchaDlg: false,
    };
  },
  components: {
    StatusBtn,
  },
  computed:{
    baseURL() {
      return config.domain + "/";
    },
    userInfo() {
      return this.getAuthObj();
    }
  },
  created: function () {
    if (this.checkPermission("EVENT_LIST_ORDER")) {
      this.canDrag = true;
    }
  },
  methods: {
    async init() {
      var objdata = this.getAuthObj();

      objdata.pageIndex = this.page;
      objdata.pageSize = this.pagesize;
      objdata.title = this.searchName;
      objdata.archived = "1"
      objdata.sortName = '';
      objdata.sortName = this.sortField;
      objdata.sortType = this.sortType;
      objdata.expired = "2";

      objdata.apiUrl = this.apiConfig.eventList;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      // this.rows = data.data.result.events;
      this.$set(this, "rows", data.data.result.events);
      this.setObj();
      this.total = data.data.result.total;
    },
    async syncEvent() {
      var objdata = this.getAuthObj();
      objdata.answer = this.answer;
      objdata.captcha = this.captcha.captcha;
      objdata.captchaId = this.captcha.captchaId;
      objdata.apiUrl = this.apiConfig.eventSync;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) {
        this.getCaptchaImageEvent();
        return;
      }
      this.page = 1;
      this.init();
      this.selectCaptchaDlg = false;
    },
    getStatus(data) {
      if (data.indexOf("all") < 0) {
        this.searchStatus = Number(data);
      } else {
        this.searchStatus = null;
      }
    },
    async search() {
      this.page = 1;
      this.init();
    },
    cancel: function () {
      this.$store.commit("setwarning", { string: "", boolean: false });
    },
    cell: function ({ row }) {
      if (!this.canDrag) {
        return "disabled pointer";
      }
      // if (row.status == 1) {
      return "cursor-move";
      // } else {
      //   return "disabled pointer";
      // }
    },
    handleDbClick: function (row) {
      this.$router.push({
        path: "/main/eventDetail",
        query: {
          id: row.eventCode,
        },
      });
    },
    gotoDetail() {
      this.$router.push({ path: "/main/eventDetail" });
    },
    async deleteList() {
      let ids = [];
      let objdata = this.getAuthObj();
      if (this.multipleSelection.length != 0) {
        for (let i = 0; i < this.multipleSelection.length; i++) {
          ids.push(this.multipleSelection[i].id);
        }
      }
      objdata.ids = ids.join(",");

      objdata.apiUrl = this.apiConfig.eventDelete;
      let data = await this.$store.dispatch("apiEventFromData", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      if (data.data.status_code === "0") {
        this.$store.commit("setwarning", {
          string: "",
          boolean: false,
          button: [],
        });
        this.init();
      }
    },
    setObj: function () {
      this.statusObj = [
        {
          value: "1",
          label: this.$i18n.t("message.Active"),
        },
        {
          value: "0",
          label: this.$i18n.t("message.Inactive"),
        },
      ];
      this.typeObj = [
        {
          value: 0,
          label: "Broadcast message",
        },
        {
          value: 1,
          label: "Promotion",
        },
      ];
      let list = null;
      for (list of this.rows) {
        if (list.status === 0) {
          list.statusName = "Draft";
        } else if (list.status == 1) {
          list.statusName = "Pending approval";
        } else if (list.status == 2) {
          list.statusName = "Pending Publish";
        } else if (list.status == 3) {
          list.statusName = "Rejected";
        } else if (list.status == 4) {
          list.statusName = "Suspended";
        } else if (list.status == 5) {
          list.statusName = "Pending Suspend";
        } else if (list.status == 6) {
          list.statusName = "Published";
        }
      }
    },
    async updateNewsOrder(newIndex, oldIndex) {
      var item = this.rows[oldIndex];
      this.rows.splice(oldIndex, 1);
      this.rows.splice(newIndex, 0, item);
      let sortOrder = [];
      let objdata = this.getAuthObj();
      for (let i = 0; i < this.rows.length; i++) {
        sortOrder.push({
          id: this.rows[i].eventCode,
          displayOrder: this.rows[i].sortOrder,
        });
      }
      objdata.lstOrderDTO = sortOrder;

      objdata.apiUrl = this.apiConfig.eventOrder;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.init();
    },
    handleSelectionChangeRows1(val){
      this.eventListSelected=val.map(i =>{
        return i.eventCode
      })
    },
    async handleArchiveEvent(){
      const param={
        lstEventCode:this.eventListSelected,
        status:0,
        ...this.userInfo
      }
      const {data:{status_code,status_message}}=await axios.post(this.baseURL +'event/updateArchivedStatus', param)
      if(status_code=='0') {
        this.init();
      }else{
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    }
  },
  mounted() {
    this.init();
    // const table = document.querySelector(".rowss .el-table__body-wrapper tbody");
    // var self = this;
    // Sortable.create(table, {
    //   onEnd({ newIndex, oldIndex }) {
    //     self.updateNewsOrder(newIndex, oldIndex);
    //   },
    //   filter: ".disabled",
    //   onMove: (event) => {
    //     return !event.related.classList.contains("disabled");
    //   },
    // });
  },
};
</script>
